import { FormikProps } from "formik";

import Stack from "components/Stack";

import { TRANSACTION_TERM_TYPE_OPTIONS } from "pages/Deal/FinancingEvents/constants";
import TransactionSelectField from "pages/Deal/FinancingEvents/TransactionFields/TransactionSelectField";
import TransactionTextField from "pages/Deal/FinancingEvents/TransactionFields/TransactionTextField";
import TransactionTypeSpecificHeader from "pages/Deal/FinancingEvents/TransactionModifyDialog/TransactionForm/TransactionTypeSpecificHeader";

import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionOtherModifyForm {
  formik: FormikProps<ITransactionValuesForm>;
  lastUpdatedInformation: string | null;
  transactionIdentifier?: string;
}

const TransactionOtherModifyForm = ({
  formik,
  transactionIdentifier,
  lastUpdatedInformation,
}: ITransactionOtherModifyForm) => (
  <>
    <TransactionTypeSpecificHeader
      transactionIdentifier={transactionIdentifier}
      transactionType={formik.values.transaction_type}
      lastUpdatedInformation={lastUpdatedInformation}
    />
    <Stack
      gap={1}
      rowGap={3}
      padding={2}
      marginTop={2}
      gridTemplateColumns="1fr 1fr"
      display="grid"
    >
      <TransactionSelectField
        formik={formik}
        options={TRANSACTION_TERM_TYPE_OPTIONS}
        inputLabel="Term type"
        fieldName="othertransaction.term_type"
      />
      <TransactionTextField
        fieldName="other_transaction.term"
        label="Term"
        isNumber
        formik={formik}
      />
      <TransactionTextField
        fieldName="other_transaction.other_sources"
        label="Other sources"
        formik={formik}
      />
      <TransactionTextField
        fieldName="other_transaction.other_sources_amount"
        label="Other sources amount"
        isNumber
        formik={formik}
        showDollarSign
      />
    </Stack>
  </>
);

export default TransactionOtherModifyForm;
